// extracted by mini-css-extract-plugin
export default {"notes":"notes_notes__1F8ba","note":"notes_note__6x8RA","info":"notes_info__Bx83u","data":"notes_data__1y+G9","noteDescription":"notes_noteDescription__pUgGq"};